import {Card, styled} from '@mui/material';
import {StyledCardProps} from './types';

const StyledCard = styled(Card)<StyledCardProps>`
	padding: 16px;
	border-radius: 8px;
	border: 1px solid transparent;
	cursor: ${({$isCursorPointer}) => ($isCursorPointer ? 'pointer' : 'default')};
	background-color: white;
	padding: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export {StyledCard};
